export default __webpack_public_path__ + "static/media/center.09fb3ae6.svg";